import React, { CSSProperties, ReactNode } from "react";
import * as styles from "./popup-sheet.module.scss";
import { classArr } from "../../helper/style-helper";

export interface PopupSheetProps {
	style?: CSSProperties;
	className?: string;
	children?: ReactNode;
}

/**
 * A container used for popup sheets
 */
export default function PopupSheet(props: PopupSheetProps) {
	return (
		<div
			style={props.style}
			className={classArr(props.className, styles.container)}
		>
			{props.children}
		</div>
	);
}
